// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"504":"__federation_expose_CMSComponent","577":"__federation_expose_HomePageBanners","892":"__federation_expose_Autocomplete"}[chunkId] || chunkId) + ".js";
};